export default {
  nameForCode (countryCode) {
    return this.forSelect().find(country => {
      return country.value.toLocaleLowerCase() === countryCode.toLocaleLowerCase()
    }).text
  },
  forSelect () {
    return [
      { text: 'Deutschland', value: 'de' },
      { text: 'Vereinigtes Königreich', value: 'gb' },
      { text: 'Frankreich', value: 'fr' },
      { text: 'Belgien', value: 'be' },
      { text: 'Österreich', value: 'at' },
      { text: 'Schweiz', value: 'ch' },
      { text: 'Niederlande', value: 'nl' }
    ]
  }
}
